import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import BASE_URL from "../api";
import { AppDispatch, RootState } from "../../../store/store";
import { Notification, NotificationState } from "../types/notification";

const initialState: NotificationState = {
    notifications: [],
    loading: false,
    unreadCount: 0,
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        start(state) {
            state.loading = true;
        },

        fail(state) {
            state.loading = false;
        },

        setNotifications(state, action: PayloadAction<Notification[]>) {
            state.notifications = action.payload;
            state.loading = false;
            state.unreadCount = action.payload.filter(n => !n.is_read).length;
        },

        addNotification(state, action: PayloadAction<Notification>) {
            state.notifications.unshift(action.payload);
            if (!action.payload.is_read) state.unreadCount += 1;
        },

        markAllAsRead(state) {
            state.notifications.forEach(n => (n.is_read = true));
            state.unreadCount = 0;
        },
        markAsRead(state, action: PayloadAction<string>) {
            const index = state.notifications.findIndex(
                (i) => i.id === action.payload
            );

            if (index !== -1 && !state.notifications[index].is_read) {
                state.notifications[index] = {
                    ...state.notifications[index],
                    is_read: true,
                };

                state.unreadCount = state.notifications.filter(
                    (n) => !n.is_read
                ).length;
            }
        }
    },
});

export const {
    start,
    fail,
    setNotifications,
    addNotification,
    markAsRead,
    markAllAsRead,
} = notificationSlice.actions;

export default notificationSlice.reducer;



export const fetchNotifications =
    () => async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(start());

        try {
            const token = getState().auth.access_token;

            const res = await fetch(`${BASE_URL}/user/notifications`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });

            const data = await res.json();

            dispatch(setNotifications(data.data || []));
        } catch (err) {
            dispatch(fail());
        }
    };


export const markNotificationAsRead =
    (id: string) =>
        async (dispatch: AppDispatch, getState: () => RootState) => {
            const token = getState().auth.access_token;

            await fetch(`${BASE_URL}/user/notifications/${id}/read`, {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });

            dispatch(markAsRead(id));

            //  OPTIONAL but IMPORTANT: sync with backend
            dispatch(fetchNotifications());
        };


export type { NotificationState };